import { changePhotoRequest as schemaChangePhotoRequest } from './schemas';
import apiClient from './apiClient';
import ChangePhotoRequestDataStore from '../../datastores/ChangePhotoRequestDataStore';

class ChangePhotoRequestDataStoreGraphQL
  implements ChangePhotoRequestDataStore
{
  client = apiClient();

  async register(
    period: string,
    imgBase64: string,
    fileType: string,
    procedureId: number
  ) {
    try {
      const response = await this.client.mutate({
        mutation: schemaChangePhotoRequest.registerChangePhotoRequestProcedure,
        variables: { period, imgBase64, fileType, procedureId }
      });
      const { data } = response;
      return data?.registerChangePhotoRequestProcedure;
    } catch (error) {
      throw new Error('error register change photo');
    }
  }

  async cancel(requestId: number, procedureId: number) {
    try {
      const response = await this.client.mutate({
        mutation: schemaChangePhotoRequest.cancelChangePhotoRequestProcedure,
        variables: { requestId, procedureId }
      });
      const { data } = response;
      return data?.cancelRequestProcedure;
    } catch (error) {
      throw new Error('error cancel change photo');
    }
  }
}

export default ChangePhotoRequestDataStoreGraphQL;
